import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import UserList, { UserListProps, UserListRouteProps } from "./UserList";
import { MainState } from "../../Core/reducers";
import React = require("react");

export const UserListWrapper = (props: UserListProps) => {
    const { didEmailFail, isSaveMessageDisplayed } = useParams() as Record<string, string>;

    return (
        <UserList
            {...props}
            didEmailFail={didEmailFail}
            isSaveMessageDisplayed={isSaveMessageDisplayed}
        />
    );
};

const mapStateToProps = (state: MainState) => ({
    currentStudyId: state.security.studyId,
});

export default connect(mapStateToProps)(UserListWrapper);
